/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_Loading_TextInputs */

const en_preset_manager_loading_text = /** @type {(inputs: Preset_Manager_Loading_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Loading presets...`)
};

const fr_preset_manager_loading_text = /** @type {(inputs: Preset_Manager_Loading_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chargement des presets...`)
};

const de_preset_manager_loading_text = /** @type {(inputs: Preset_Manager_Loading_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voreinstellungen werden geladen...`)
};

const it_preset_manager_loading_text = /** @type {(inputs: Preset_Manager_Loading_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caricamento preset in corso...`)
};

const ru_preset_manager_loading_text = /** @type {(inputs: Preset_Manager_Loading_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Загрузка предустановок...`)
};

const es_preset_manager_loading_text = /** @type {(inputs: Preset_Manager_Loading_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cargando ajustes preestablecidos...`)
};

const zh_cn2_preset_manager_loading_text = /** @type {(inputs: Preset_Manager_Loading_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在加载预设……`)
};

const ja_preset_manager_loading_text = /** @type {(inputs: Preset_Manager_Loading_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プリセットを読み込んでいます...`)
};

const hi_preset_manager_loading_text = /** @type {(inputs: Preset_Manager_Loading_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रीसेट लोड हो रहे हैं...`)
};

const pt_pt2_preset_manager_loading_text = /** @type {(inputs: Preset_Manager_Loading_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregando predefinições...`)
};

/**
* | output |
* | --- |
* | "Loading presets..." |
*
* @param {Preset_Manager_Loading_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_loading_text = /** @type {((inputs?: Preset_Manager_Loading_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_Loading_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_preset_manager_loading_text(inputs)
	if (locale === "de") return de_preset_manager_loading_text(inputs)
	if (locale === "it") return it_preset_manager_loading_text(inputs)
	if (locale === "ru") return ru_preset_manager_loading_text(inputs)
	if (locale === "es") return es_preset_manager_loading_text(inputs)
	if (locale === "zh-CN") return zh_cn2_preset_manager_loading_text(inputs)
	if (locale === "ja") return ja_preset_manager_loading_text(inputs)
	if (locale === "hi") return hi_preset_manager_loading_text(inputs)
	if (locale === "pt-PT") return pt_pt2_preset_manager_loading_text(inputs)
	return en_preset_manager_loading_text(inputs)
});